module.exports = __webpack_public_path__ + "static/23e3c60cc9cc83d6a0f4827c90e977076d2c2580d7c3634953a6a94929c2c718-95a6ed381da23583773b52b182500b50.png";